import Button from "../ui/Button"
export default function Hero() {
    return (
        <div id="home" className="flex flex-col justify-items-center min-h-full p-9 gap-7 items-center">
            <h1 className="font-display text-5xl font-bold tracking-wider">
                Hi, I'm <span className="drop-shadow-[0_0_10px_rgba(59,_130,_246,_0.8)]">Nacim Oualla</span>
            </h1>
            <h2 className="font-display text-3xl font-bold tracking-wider">Tech Enthusiast & Developer</h2>
            <div className="flex gap-8">
                <Button>View My Work</Button>
                <Button variant="secondary">Contact Me</Button>
            </div>
        </div>
    )
}